/*-----------Types of INSCRIPTION actions--------*/

/*---SAVE----*/
export const INSCRIPTION_SAVE_SUCCESS = "INSCRIPTION_SAVE_SUCCESS";
export const INSCRIPTION_SAVE_FAILED = "INSCRIPTION_SAVE_FAILED";
export const INSCRIPTION_IS_SAVING = "INSCRIPTION_IS_SAVING";
/*---FETCH----*/
export const INSCRIPTION_FETCH_SUCCESS = "INSCRIPTION_FETCH_SUCCESS";
export const ONE_INSCRIPTION_FETCH_SUCCESS = "One_INSCRIPTION_FETCH_SUCCESS";
export const INSCRIPTION_FETCH_FAILED = "INSCRIPTION_FETCH_FAILED";
export const INSCRIPTION_IS_FETCHING = "INSCRIPTION_IS_FETCHING";
/*---UPDATE----*/
export const INSCRIPTION_UPDATE_SUCCESS = "INSCRIPTION_UPDATE_SUCCESS";
export const INSCRIPTION_UPDATE_FAILED = "INSCRIPTION_UPDATE_FAILED";
export const INSCRIPTION_IS_UPDATING = "INSCRIPTION_IS_UPDATING";

/*---PATCH----*/
export const INSCRIPTION_PATCH_SUCCESS = "INSCRIPTION_PATCH_SUCCESS";
export const INSCRIPTION_PATCH_FAILED = "INSCRIPTION_PATCH_FAILED";
export const INSCRIPTION_IS_PATCHING = "INSCRIPTION_IS_PATCHING";


/*---DELETE----*/
export const INSCRIPTION_DELETE_SUCCESS = "INSCRIPTION_DELETE_SUCCESS";
export const INSCRIPTION_DELETE_FAILED = "INSCRIPTION_DELETE_FAILED";
export const INSCRIPTION_IS_DELETING = "INSCRIPTION_IS_DELETING";